import { palette } from '@eversports/design-tokens/palette'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../localization/react'
import { invoiceStatusColorMapping, invoiceStatusLabelMapping } from '../InvoiceHistory.constants'
import { InvoiceState } from '../InvoiceHistory.types'

interface Props {
  invoiceState: InvoiceState
}

const InvoiceStatusBadge = ({ invoiceState }: Props) => (
  <Box
    px={2}
    py={1}
    sx={{
      background: `${palette[invoiceStatusColorMapping[invoiceState]]}1F`,
      borderRadius: 0.5,
      width: 'fit-content',
    }}
  >
    <Text color={invoiceStatusColorMapping[invoiceState]} variant="label">
      <Localized id={invoiceStatusLabelMapping[invoiceState] as any} />
    </Text>
  </Box>
)

export default InvoiceStatusBadge
